import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";

// SCN04

const RegistEmailInformPage = () => {
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [logoVkorg, setLogoVkorg] = useState(logoCCBJI);
    const location = useLocation();
    const navigate = useNavigate();
    const props = location.state || null;

    // On mount: Check if props exist and set state accordingly
    useEffect(() => {
        if (!props) {
            navigate('/login');
        } else if (props && props.showSuccessRegistEmailModal == true && props.showVkog) {
            setLogoVkorg(props.showVkog);
            setShowSuccessModal(true)
        }
    }, [navigate, props]);

    // If state not valid, render nothing
    if (!showSuccessModal) {
        return <></>
    }

    // Handler for clicking the logo (go back to login)
    const backToLogin = () => {
        navigate('/login');
    }

    // UI Render
    return (
        <Fragment>
            <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white p-0" >
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item d-flex justify-content-around" onClick={backToLogin} style={{ height: '71px' }}>
                        <img className="m-1" src={logoVkorg} alt="Logo 1" style={{ height: '90%' }} />
                    </li>
                </ul>
            </nav >
            <div className="container-fluid background-cover-external">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item active">初期アドレス登録完了</li>
                </ol>
                <div className="jumbotron">
                    <div className="section">
                        <div className="card-body" style={{ minHeight: '45vh' }}>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                    <p>
                                        <span>入力頂いたメールアドレスに仮登録用URLを送信致しました。</span> <br />
                                        <span>メールのURLより仮登録を実施してください。</span>
                                    </p>
                                    <p>
                                        <span>
                                            5分経ってもメールが確認できない場合はお手数ですが再度メールアドレスの入力を行ってください。
                                        </span>
                                    </p>
                                    <p>
                                        <span>ご登録用URLの有効期間は、発行から24時間となっております。</span> <br />
                                        <span>期限を過ぎた場合は、再度お手続きいただく必要がございますので、あらかじめご了承ください。</span>
                                    </p>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default RegistEmailInformPage;
